import { FC } from 'react';
import { MasonryGrid } from '../../../ui/layout/MasonryGrid/MasonryGrid';
import { PostCardGrid } from '../../../ui/posts/PostCardGrid/PostCardGrid';
import { PostCollectionCardGrid } from '../../../ui/posts/PostCardGrid/PostCollectionCardGrid';
import { EventSource } from '../../../utils/analyticsService';
import { ROBOT_IMAGE_ALIAS } from '../../post/utils/constants';
import { getPostGridLink } from '../../post/utils/getPostGridLink';
import { withPostCallbacks } from '../../post/withPostCallbacks';
import { BusinessGridBox } from './BusinessGridBox';
import type { BusinessResizableGridProps } from './types';
import type { PostModel } from '../../../data-layer/posts/types';

const EnchancedPostGridCard = withPostCallbacks(PostCardGrid, EventSource.BUSINESS);

const EnhancedCollectionCardGrid = withPostCallbacks(PostCollectionCardGrid, EventSource.BUSINESS);

type RobotBusinessGridProps = Pick<BusinessResizableGridProps, 'items' | 'isService'>;

/** Сетка постов бизнеса для робота: без виртуализации, кебаба и догрузки — всё это требует JS */
export const RobotBusinessGrid: FC<RobotBusinessGridProps> = ({ items, isService = false }) => {
    const posts = items.filter((item): item is PostModel & { isAd: false } => !item.isAd);

    const renderItem = (post: PostModel, index: number) => {
        const { href, isExternal } = getPostGridLink(post);

        if (post.postType === 'collection') {
            return (
                <EnhancedCollectionCardGrid
                    post={post}
                    index={index}
                    href={href}
                    imageAlias={ROBOT_IMAGE_ALIAS}
                />
            );
        }

        return (
            <EnchancedPostGridCard
                post={post}
                index={index}
                href={href}
                isExternalHref={isExternal}
                imageAlias={ROBOT_IMAGE_ALIAS}
                showFooter={false}
                withProductsPreview={!isService}
                isCompact
            />
        );
    };

    if (!posts.length) {
        return null;
    }

    return (
        <BusinessGridBox>
            <MasonryGrid items={posts} renderItem={renderItem} />
        </BusinessGridBox>
    );
};
